// Import required libraries
import React, { useReducer } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

// Import custom components
import AlertManagerForm from "./AlertsCreateHelpers";

// Import utils/data
import useReducerLogger from "../../../utils/useReducerLogger";

// Import reducer
import alertFormReducer from "../../../redux/reducers/alertForm";

// Import styles
import "./Alerts.scss";

function AlertsManager(props) {
  const { t } = useTranslation();
  // * Destructure props
  const {
    dispatch: ReduxDispatcher,
    state: selectedState,
    user,
    allData,
    globalFilters,
    showAlertManager,
    setShowAlertManager,
    setSelectedAlertId,
    reloadData,
    setReloadData,
    alertFormDataOriginal,
    activeAlertNav,
    setActiveAlertNav,
    alerts,
  } = props;

  // // Defining the main reducer
    const [state, dispatch] = useReducer(
      useReducerLogger(alertFormReducer),
      selectedState
    );

  // Defining required variables for the alert manager form props
  const alertManagerFormProps = {
    state,
    dispatch,
    user,
    globalFilters,
    allData,
    ReduxDispatcher,
    setShowAlertManager,
    reloadData,
    setReloadData,
    alertFormDataOriginal,
    activeAlertNav,
    setActiveAlertNav,
    setSelectedAlertId,
  };

  return (
      <div className="alerts-manager-form">
        <div className="alerts-content-container">
          <div
            className="alerts-right-panel"
          >
            {/* AlertManagerForm jsx */}
            {showAlertManager && (
              <AlertManagerForm
                {...alertManagerFormProps}
                alertsName={`Pattern + ${alerts.result.length + 1}`}
              />
            )}
          </div>
        </div>
      </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  globalFilters: state.globalFilters,
});

export default connect(mapStateToProps)(AlertsManager);
